import { render } from "./CountryStatusEmailContent.vue?vue&type=template&id=5a1a3d22"
import script from "./CountryStatusEmailContent.vue?vue&type=script&lang=js"
export * from "./CountryStatusEmailContent.vue?vue&type=script&lang=js"
script.render = render

export default script